import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useOfferMutation = createMutationHook(OffersApiClient.updateOffer, {
  mutationKey: ['offer'],
})
